import { Component, OnInit, Input } from '@angular/core';
import { MaterialsPhaseDto } from "../../data/CommandServiceDtos.generated";

@Component({
  selector: 'project-materials-substage',
  templateUrl: './project-materials-substage.component.html',
  styleUrls: ['./project-materials-substage.component.scss']
})
export class ProjectMaterialsSubstageComponent implements OnInit {
  @Input() phase: MaterialsPhaseDto;
  constructor() { }

  ngOnInit(): void {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/project-materials-substage/project-materials-substage.component.ts